import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=067d4ab2&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=js&"
export * from "./Recipients.vue?vue&type=script&lang=js&"
import style0 from "./Steps.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Recipients.vue?vue&type=style&index=1&id=067d4ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d4ab2",
  null
  
)

export default component.exports